
















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/components/UI/Modal.vue';
import IconPaymentKlarna from '@/components/SvgIcons/IconPaymentKlarna.vue';
import IconPaymentPaypal from '@/components/SvgIcons/IconPaymentPaypal.vue';
import HipayCard from '@/components/Checkout/PaymentStep/HipayCard.vue';
import store from '@/store';
import checkout from '@/store/modules/checkout';
import payment from '@/store/modules/payment';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import { PaymentMethod } from '@/store/models';
import { i18n } from '@/i18n';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    Modal,
    IconPaymentKlarna,
    IconPaymentPaypal,
    HipayCard,
  },
})
export default class PaymentStep extends Vue {
  private loading: boolean = false;

  private mounted() {
    if (this.selected === 'klarna_pay_later') {
      this.reloadKlarnaWidget();
    }
  }

  @Watch('grandTotal')
  private onTotalsChange(val: any, oldVal: any) {
    this.reloadKlarnaWidget();
  }

  get hasPlaceError(): boolean {
    return checkout.hasPlaceErrorByCode('payment_selection');
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get selected(): string { // tutorial: il metodo get si traduce in una computed property
    return checkout.selectedPayment;
  }

  // tutorial: il metodo set si traduce nel setter di una computed property.
  // Tipicamente qui committeremo una mutation
  set selected(value: string) {
    gtmhelpers.trackSetPaymentMethod(
        gtmhelpers.convertProductsData(cart.cart.items),
        cart.totals.grand_total,
        cart.totals.quote_currency_code,
        checkout.coupon.coupon,
        value
    );
    cart.flagLoading({key: 'paymentselection', value: true});
    checkout.setPayment(value).finally(() => {
      checkout.resetPlaceErrors('payment_selection');
      checkout.goingToStep({fromStep: 'payment', toStep: 'review' });
      cart.flagLoading({key: 'paymentselection', value: false});
      if (value === 'klarna_pay_later') {
        this.reloadKlarnaWidget();
      }
    });
  }

  get isMethodLoading(): boolean {
    return cart.loadingFlags.paymentselection;
  }

  get methods(): PaymentMethod[] {
    const priority: any = {
      hipay: 10,
      hipay_paypal: 20,
      yandex: 30,
      klarna_pay_later: 40,
      phoenix_cashondelivery: 100,
      default: 999,
    };
    const paymentMethods = checkout.allPaymentMethods.filter((pm: PaymentMethod) => pm.code !== 'amazon_payment');
    paymentMethods.sort((a: any, b: any) => {
      const pa = priority[a.code] || priority.default;
      const pb = priority[b.code] || priority.default;
      return pa < pb ? -1 : (pb < pa ? 1 : 0);
    });
    return paymentMethods;
  }

  get grandTotal(): number  {
    return cart.totals.grand_total;
  }

  get selectedMethod(): PaymentMethod {
    return checkout.selectedPaymentMethod;
  }

  get isYandexModalLoading(): boolean {
    return cart.loadingFlags.yandex;
  }

  get isHipayModalLoading(): boolean {
    return cart.loadingFlags.hipay;
  }

  get cashOnDeliveryCost(): string {
    return store.state.options.payment.cashondelivery_fee;
  }

  get hipayCardsEnabled(): boolean {
    const hipayConfig = store.state.options.payment.hipayConfig;
    return hipayConfig.show_tokenized_cards || hipayConfig.use_hostedfields;
  }

  get cc_icons(): Array<{title: string, url: string}> {
    const allcards = store.state.options.payment.cc_icons;
    const usecards = [];
    if (allcards) {
      usecards.push(allcards.AE);
      usecards.push(allcards.VI);
      usecards.push(allcards.MC);
      usecards.push(allcards.MI);
    }
    return usecards;
  }

  get unlocked(): boolean {
    return checkout.stepByName('payment').unlocked;
  }

  private reloadKlarnaWidget() {
    this.$nextTick(() => {
      setTimeout(() => {
        payment.callMethodApi({paymentMethod: 'klarna', apiMethod: 'loadWidgetApi', apiParams: 'pay_later'});
      }, 1500);
    });
  }

  private closePaymentModal(modalId: string) {
    ui.closeModal(modalId);
    checkout.flagPlacingOrder(false);
    this.loading = false;
  }

  private paymentExists(method: string) {
    return checkout.hasPaymentMethod(method);
  }

  private isActive(method: PaymentMethod): boolean {
    return method.code === checkout.selectedPayment;
  }

  private canShowHipayCard(method: PaymentMethod): boolean {
    const hipayConfig = store.state.options.payment.hipayConfig;
    const active = method.code === 'hipay' && this.isActive(method);
    return active && ((hipayConfig.show_tokenized_cards && this.isLogged) || hipayConfig.use_hostedfields);
  }

  private getTitle(method: PaymentMethod): string {
    if (method.code.indexOf('klarna') !== -1) {
      switch (method.code) {
        case 'klarna_pay_later':
          return i18n.t('Buy now, pay later').toString();
      }
    }

    if (this.hasNotes(method)) {
      const title =  method.title.split('|');
      return title[0];
    }

    return method.title;
  }

  private hasNotes(method: PaymentMethod): boolean { // tutorial: un normale metodo si traduce in un method di Vue
    return method.title ? method.title.includes('|') : false;
  }

  private getNotes(method: PaymentMethod): string {
    if (this.hasNotes(method)) {
      const title =  method.title.split('|');
      return title[1];
    }
    return '';
  }

}
